// extracted by mini-css-extract-plugin
module.exports = {"sideImgCard":"AssetCard_sideImgCard__UcJke","cardBody":"AssetCard_cardBody__1k9LK","cardTitle":"AssetCard_cardTitle__F3sDf","cardSubtitle":"AssetCard_cardSubtitle__f5iaR"};